__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-10-07-1791376899-stable-dev/";